import React from "react";
import cn from "classnames";

export const TableRenderUtils = {
  renderHeaderForNumericContent: (
    content: string | JSX.Element,
    conf?: { className?: string },
  ) => {
    return <div className={cn("text-right", conf?.className)}>{content}</div>;
  },

  renderHeaderCenter: (
    content: string | JSX.Element,
    conf?: { className?: string },
  ) => {
    return <div className={cn("text-center", conf?.className)}>{content}</div>;
  },

  renderNumericContent: (
    content: string | number | JSX.Element,
    conf?: { className?: string },
  ) => {
    return <div className={cn("text-right", conf?.className)}>{content}</div>;
  },

  renderBaseContent: (
    content: string | number | null | JSX.Element,
    conf?: { className?: string },
  ) => {
    return (
      <div
        className={cn("text-sm text-gray-500 dark:text-white", conf?.className)}
      >
        {content}
      </div>
    );
  },

  renderActionButton: (content: JSX.Element, conf?: { className: string }) => {
    return <div className={cn("text-right", conf?.className)}>{content}</div>;
  },
};
